import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Logo.module.scss';

export default function Logo() {
  const navigate = useNavigate();

  const goToTasksPage = () => {

    if (window.location.pathname === '/login') {
      window.location.href = 'https://nekst.com';
    } else if (window.location.pathname !== '/tasks') {
      navigate('/tasks');
    }
  };

  const logoPath = '/nekst_logo.new.svg';

  return (
    <a
      href="/tasks"
      className={styles.logo}
      onClick={(event) => {
        event.preventDefault();
        goToTasksPage();
      }}
    >
      <img src={logoPath} alt="logo" style={{ width: '11.4rem'}} />
    </a>
  );
}
